import { compact, chain } from 'lodash';
import generateAbilityScores from './generateAbilityScores';
import generateCombatStats from './generateCombatStats';
import generateHitPoints from './generateHitPoints';
import generateProficiencies from './generateProficiencies';
import generateLanguages from './generateLanguages';
import generateEquipment from './generateEquipment';
import generateCarryingCapacity from './generateCarryingCapacity';
import generateSuperiorty from './generateSuperiority';
import generateCasting from './generateCasting';
import generateFeatures from './generateFeatures';
import generateFeats from './generateFeats';
import generateWeapons from './generateWeapons';
import applyTweak from '@/utilities/applyTweak';
import generateExperiencePoints from './generateExperiencePoints';
import generateAttunement from './generateAttunement';
export default function generateCharacter(rawCharacter, classes, archetypes, species, equipment, enhancedItems, powers, maneuvers, feats, features, backgrounds, characterAdvancements, skills, conditions) {
    // To Do
    const classText = rawCharacter.classes
        .map(({ name, levels, archetype }) => `${name}${archetype ? ` (${archetype.name})` : ''} ${levels}`)
        .join(', ');
    const myClasses = rawCharacter.classes.map(({ name }) => classes.find(myClass => name === myClass.name));
    if (myClasses.includes(undefined))
        console.error('Class not found from ' + rawCharacter.classes.map(({ name }) => name));
    const myFoundClasses = compact(myClasses);
    const consular = classes.find(myClass => myClass.name === 'Consular'); // Used in place of Multiclass Max Power Level Table for now
    if (!consular)
        console.error('Class not found: consular');
    const myArchetypes = compact(rawCharacter.classes.map(({ archetype }) => archetype && archetypes.find(myArchetype => archetype.name === myArchetype.name)));
    const skillsMap = chain(['Strength', 'Dexterity', 'Constitution', 'Intelligence', 'Wisdom', 'Charisma'])
        .keyBy()
        .mapValues(ability => skills.filter(({ baseAttribute }) => ability === baseAttribute).map(({ name }) => name))
        .value();
    const conditionsMap = chain(conditions)
        .keyBy('name')
        .mapValues(({ description }) => description.replace(/\\r\\n/g, '\n'))
        .value();
    const mySpecies = species.find(({ name }) => name === rawCharacter.species.name);
    if (!mySpecies)
        console.error('Species not found: ', rawCharacter.species.name);
    const currentLevel = rawCharacter.classes.reduce((acc, { levels }) => acc + levels, 0);
    const proficiencyBonus = applyTweak(rawCharacter, 'proficiencyBonus', 1 + Math.ceil(currentLevel / 4));
    const experiencePoints = generateExperiencePoints(rawCharacter, characterAdvancements, currentLevel);
    const myFeats = generateFeats(rawCharacter, feats);
    const { abilityScores, skillAndSaveProficiencies } = generateAbilityScores(rawCharacter, myFoundClasses, mySpecies, proficiencyBonus, skillsMap);
    const myConditions = rawCharacter.currentStats.conditions.map(condition => ({
        name: condition,
        description: conditionsMap[condition]
    }));
    const myBackground = backgrounds.find(({ name }) => name === rawCharacter.background.name);
    const proficiencies = generateProficiencies(rawCharacter, myFoundClasses, myBackground);
    const myEquipment = generateEquipment(rawCharacter, equipment, enhancedItems, abilityScores, proficiencyBonus, proficiencies);
    const casting = generateCasting(rawCharacter, abilityScores, powers, proficiencyBonus, myFoundClasses, consular, myArchetypes);
    const superiority = generateSuperiorty(rawCharacter, myFoundClasses, myArchetypes, abilityScores, proficiencyBonus, maneuvers);
    const myFeatures = generateFeatures(rawCharacter, features, currentLevel, myFeats, myBackground, backgrounds, abilityScores);
    return {
        name: rawCharacter.name,
        builderVersion: rawCharacter.builderVersion,
        image: rawCharacter.image,
        characteristics: rawCharacter.characteristics,
        tweaks: rawCharacter.tweaks,
        customProficiencies: rawCharacter.customProficiencies,
        customLanguages: rawCharacter.customLanguages,
        customFeatures: rawCharacter.customFeatures,
        customTechPowers: rawCharacter.customTechPowers,
        customForcePowers: rawCharacter.customForcePowers,
        customEquipment: rawCharacter.customEquipment,
        numCustomFeats: rawCharacter.customFeats.length,
        currentLevel,
        classText,
        alignment: rawCharacter.characteristics.alignment,
        species: rawCharacter.species.name,
        background: rawCharacter.background.name,
        experiencePoints,
        abilityScores,
        proficiencyBonus,
        ...generateCombatStats(rawCharacter, abilityScores, myEquipment),
        hitPoints: generateHitPoints(rawCharacter, abilityScores, myFoundClasses, currentLevel, myFeatures),
        conditions: myConditions,
        exhaustion: rawCharacter.currentStats.exhaustion,
        proficiencies,
        skillAndSaveProficiencies,
        languages: generateLanguages(rawCharacter),
        equipment: myEquipment,
        attunement: generateAttunement(myEquipment, proficiencyBonus),
        weapons: generateWeapons(rawCharacter, myEquipment, abilityScores, proficiencyBonus),
        credits: Math.max(rawCharacter.credits, 0),
        carryingCapacity: generateCarryingCapacity(abilityScores),
        superiority,
        ...casting,
        ...myFeatures,
        settings: rawCharacter.settings,
        notes: rawCharacter.notes
    };
}
